/**
 * lib/highlight.ts — where a search answer's title and artist hold the query (task 72).
 *
 * `docs/superpowers/specs/2026-10-25-oblik-afisha-design.md` «Поиск»: in gold, the places where
 * the query's text stands in the name LITERALLY, regardless of case. The server finds more than
 * that (`apps/api/src/db/queries/search.ts`): word by word, in every field — the riddim, the
 * tags, the year, the caption — through the normalised key, and with Latin and Cyrillic folded
 * into one another (`.omc/wiki/normalizaciya-i-translit.md`). Those matches are found and not
 * marked: a mark that a person cannot see in the letters would look like a mistake.
 */

/** One piece of a text: marked or not. Joined in order, the pieces are the text. */
export interface Piece {
  readonly text: string;
  readonly hit: boolean;
}

/** `text` cut into pieces at every place `query` (trimmed) stands in it, case aside. */
export function markMatches(text: string, query: string): Piece[] {
  const needle = query.trim().toLowerCase();
  if (needle === '' || text === '') return [{ text, hit: false }];
  const haystack = text.toLowerCase();
  // Lower case can change a string's length (a dotted «İ»): then marks would land off the letters.
  if (haystack.length !== text.length) return [{ text, hit: false }];
  const pieces: Piece[] = [];
  let from = 0;
  for (let at = haystack.indexOf(needle); at !== -1; at = haystack.indexOf(needle, from)) {
    if (at > from) pieces.push({ text: text.slice(from, at), hit: false });
    pieces.push({ text: text.slice(at, at + needle.length), hit: true });
    from = at + needle.length;
  }
  if (from < text.length) pieces.push({ text: text.slice(from), hit: false });
  return pieces.length === 0 ? [{ text, hit: false }] : pieces;
}
